import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import ColorTag from 'components/ColorTag'

import { ReactComponent as Bottom } from '../icons/bottom.svg'

import { DefaultCardHeader, DefaultCardBody } from 'components/Card'

export const TreeViewRoot = styled(({ inverted, ...props }) => <Row {...props}/>)`
	max-height: ${({ maxheight }) => maxheight};
	overflow: ${({ maxheight }) => maxheight ? 'auto' : 'unset'};
`

export const PositionedColorTag = styled(ColorTag)`
	position: absolute;
	border-bottom: 1px solid #fff;
	top: 0;
	left: 0;
`

export const CardHeader = styled(DefaultCardHeader)`
	height: 44px !important;
	color: ${({ isSelected, theme }) => isSelected ? theme.activeColor : '#fff'} !important;
	cursor: ${({ isSelectable }) => isSelectable ? 'pointer' : 'unset'};
	> div {
		margin-right: 0 !important;
		margin-bottom: 0 !important;
	}
`

export const MainContainer = styled(Col)`
	margin-bottom: 10px;
`

export const MainInnerContainer = styled.ul`
	background: ${({ inverted }) => inverted ? '#f5f5f5' : '#fff'};
`

export const StyledInnerElement = styled.div`
	position: relative;
	cursor: ${({ isSelectable }) => isSelectable ? 'pointer' : 'unset'};
	border-bottom: ${({ noBorder }) => noBorder ? 'none' : 'solid 1px #f5f5f5'};
	${({ marginLeft })=>marginLeft && `margin-left: ${marginLeft}px;`}
	height: 44px;
	display: flex;
  align-items: center;
  padding-left: 24px;
  > div {
		margin-right: 0 !important;
		margin-bottom: 0 !important;
	}
`

export const RightSideContainer = styled.div`
	display: flex;
	align-items: center;
	margin-left: auto;
	height: 100%;
	width: ${({ width }) => width}
`

const ToggleOpenContainer = styled.div`
	height: 100%;
	width: 44px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`

const DropdownIndicator = styled.span`
	border-color: ${({ theme }) => `${theme.primaryColor} transparent transparent;`}
  border-style: solid;
  border-width: 6px 4px 2px;
  display: inline-block;
  height: 0;
  width: 0;
  ${({ isOpened }) => isOpened && `
	  border-color: transparent transparent #000;
	  border-width: 0 4px 6px;
  `}
`

export const NoData = ({ isSelectable, isLeaf }) => {
	const [t] = useTranslation()
	return (
		<StyledInnerElement paddingLeft={isLeaf && 48} noBorder={isLeaf} noBackground={isLeaf}>
			{/* {isSelectable && <PositionedColorTag/>} */}
			{isLeaf && <Bottom style={{ marginBottom: 'auto', marginRight: '5px' }}/>}
			{t('common.strings.empty_list')}
		</StyledInnerElement>
	)
}
export const ToggleOpenButton = ({ toggleOpened, isOpened }) => {
	return(
		<ToggleOpenContainer onClick={toggleOpened}>
			<DropdownIndicator isOpened={isOpened}/>
		</ToggleOpenContainer>
	)
}
